import { observer } from 'mobx-react';
import style from './MobileView.module.scss';
import { Popup, PopupModifiers } from '@components/Popup';
import { PatientInfo } from './components/PatientInfo';
import { Chat } from '@common/Chat/Chat';
import { PatientApp } from '@common/PatientApp';
import { isPatientAppEnabled } from '@common/PatientApp/utils/isPatientAppEnabled';
import { store } from '@store';

interface MobileViewProps {
    patientName: string;
    isPatientInfoShowing: boolean;
    togglePatientInfoShowing(): void;
}

export const MobileView = observer(
    ({ patientName, isPatientInfoShowing, togglePatientInfoShowing: togglePatientInfoDisplay }: MobileViewProps) => {
        return (
            <div className={style.root}>
                <div
                    className={style.name}
                    onClick={togglePatientInfoDisplay}
                >
                    {patientName}
                </div>
                {isPatientInfoShowing && (
                    <Popup
                        modifiers={[PopupModifiers.Redesign, PopupModifiers.NoPaddings, PopupModifiers.FromTop]}
                        onOutOfContentClick={togglePatientInfoDisplay}
                    >
                        <PatientInfo togglePatientInfoShowing={togglePatientInfoDisplay} />
                    </Popup>
                )}
                <div className={style.contactsButton}>
                    {isPatientAppEnabled() ? (
                        <PatientApp
                            hideAppLabel={!!store.app.headerView.rightContent}
                            hideSubscriptionLabel
                        />
                    ) : (
                        <Chat hideLabel={!!store.app.headerView.rightContent} />
                    )}
                </div>
            </div>
        );
    },
);
